// external dependencies
import React from 'react'
import styled from '@emotion/styled'
import { string, node } from 'prop-types'

// styled components
const YouAreHereTick = styled.div`
	border-color: ${({ theme, borderColor }) =>
		`${borderColor || theme.colors.teal} transparent transparent transparent`};
	border-style: solid;
	border-width: 1rem;
	bottom: ${({ bottom = `-2rem` }) => bottom};
	color: ${({ theme }) => theme.colors.text};
	left: 4rem;
	position: absolute;
`

MapTick.propTypes = {
	children: node,
	innerTickBorderColor: string,
	tickBorderColor: string,
}

export function MapTick({ tickBorderColor, innerTickBorderColor, children }) {
	return (
		<>
			{children}
			<YouAreHereTick borderColor={tickBorderColor}></YouAreHereTick>
			<YouAreHereTick borderColor={innerTickBorderColor || '#fff'} bottom="-1.6rem"></YouAreHereTick>
		</>
	)
}
